import { create, tsx } from '@dojo/framework/core/vdom';

import * as css from './SitepenLogo.m.css';

const logo = require('../assets/images/illustration/sitepen-logo.svg');

export interface SummaryProperties {
	lazy?: boolean;
}

const factory = create().properties<SummaryProperties>();

export const SitePenLogo = factory(function SitePenLogo({ properties }) {
	const { lazy = true } = properties();
	return <img classes={[css.root]} alt="" src={logo} loading={lazy ? 'lazy' : 'eager'} />;
});

export default SitePenLogo;
